import { Typography, Box, keyframes, styled } from "@mui/material";

const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
  100% { transform: translateY(0px); }
`;

const FloatingTypography = styled(Typography)({
  animation: `${floatAnimation} 3s ease-in-out infinite`,
});

export const ContactHeader = () => (
  <Box sx={{ textAlign: "center", mb: 6, mt: 15 }}>
    <FloatingTypography
      variant="h2"
      gutterBottom
      sx={{
        color: "primary.dark",
        fontWeight: 700,
        mb: 2,
        background: "linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        display: "inline-block",
      }}
    >
      Contact Us
    </FloatingTypography>
    <Typography
      variant="h6"
      sx={{
        color: "text.secondary",
        maxWidth: 700,
        mx: "auto",
        fontStyle: "italic",
      }}
    >
      Help us improve Halal World by sharing your suggestions or reporting
      issues
    </Typography>
  </Box>
);
